import i18next from 'i18next'
import { List } from 'immutable'
import {
  AsyncState,
  listFromOption,
  loadingAsyncState,
} from 'widgets-for-react'
import { TypeCastingValidator, canSafelyCast } from '../../../../utils/safe-type-casting'
import {
  KnowledgeTypeTeaserData,
  KnowledgeTypeTeasersData,
} from './knowledgeTypeTeasersState'

export async function getKnowledgeTypeTeasersData(): Promise<any> {
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  const response = await fetch(
    `/api/v1/knowledge/count?language=${i18next.language}`,
    {
      method: 'get',
      headers: headers,
    }
  )
  if (!response.ok) throw Error(response.statusText)
  return await response.json()
}

const knowledgeTypeTeasersDataValidator: TypeCastingValidator<KnowledgeTypeTeaserData> =
  {
    kind: 'object',
    fieldsValidator: {
      KnowledgeType: { kind: 'string' },
      Count: { kind: 'number' },
    },
  }

export const loadKnowledgeTypeTeasersData: AsyncState<KnowledgeTypeTeasersData> =
  loadingAsyncState<KnowledgeTypeTeasersData>(() =>
    getKnowledgeTypeTeasersData().then((raw) =>
      Array.isArray(raw)
        ? {
            kind: 'result',
            value: List(raw)
              .map((v) =>
                canSafelyCast<KnowledgeTypeTeaserData>(
                  knowledgeTypeTeasersDataValidator,
                  v
                )
              )
              .flatMap<KnowledgeTypeTeaserData>(listFromOption)
              .toArray(),
            status: 200,
          }
        : {
            kind: 'failed',
            status: 404,
          }
    )
  )
